// extracted by mini-css-extract-plugin
export var button = "_m-0";
export var buttonContent = "_m-e";
export var buttonGroup = "_m-c";
export var dontRestrainIconWidth = "_m-a";
export var dropdownButton = "_m-b";
export var iconContainer = "_m-9";
export var lg = "_m-4";
export var md = "_m-3";
export var pending = "_m-f";
export var sm = "_m-2";
export var spinner = "_m-d";
export var squared = "_m-8";
export var wrapText = "_m-g";
export var xl = "_m-5";
export var xs = "_m-1";
export var xxl = "_m-6";
export var xxxl = "_m-7";